import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import colors from 'global/styles/colors';
import { get } from 'global/lib/lodash';
import { getViewStyle } from 'redux/actions/view';
import isLoggedIn from 'global/utils/isLoggedIn';

export const THEMEDEFAULTS = {
  palette: {
    primary: red,
    secondary: blue,
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1040,
      xl: 1640,

      sidebar: 300,
      content: 768,
      ad: 300,
      container: 1400,
    },
  },
  colors: {
    ...colors,
  },
  overrides: {
    MuiButton: {
      root: {
        lineHeight: 1.5,
      },
    },
    MuiAppBar: {
      root: {
        zIndex: 900,
      },
    },
    MuiSvgIcon: {
      root: {
        transition: 'none',
      },
    },
  },
};

const theme = createMuiTheme({
  ...THEMEDEFAULTS,
});

export default (props) => {
  const [currentTheme, setCurrentTheme] = useState(theme);
  const viewStyle = useSelector((state) => get(state, 'view.style'));
  const auth = useSelector((state) => state.auth);
  const loggedIn = isLoggedIn(auth);
  const dispatch = useDispatch();

  useEffect(() => {
    if (loggedIn) {
      const rid = get(auth, 'realm.id');
      dispatch(getViewStyle(rid));
    } else {
      setCurrentTheme(createMuiTheme({ ...THEMEDEFAULTS }));
    }
  }, [loggedIn]);

  useEffect(() => {
    const newTheme = { ...THEMEDEFAULTS };
    if (get(viewStyle, 'palette.primary.main') && get(viewStyle, 'palette.secondary.main')) {
      delete newTheme.palette.primary;
      delete newTheme.palette.secondary;
      setCurrentTheme(createMuiTheme({ ...newTheme, ...viewStyle }));
    }
  }, [viewStyle]);

  return <MuiThemeProvider theme={currentTheme}>{props.children}</MuiThemeProvider>;
};
